import { useQuery } from '@shared/modules/use-query/hooks'
import { ServiceCategory } from '../types/categories'
import { useCallback, useMemo } from 'react'
import { ServiceCategoriesService } from '../services/categories'

export const useServiceCategoryList = () => {
  return useQuery<ServiceCategory[]>(
    useCallback(async () => {
      const result = await ServiceCategoriesService.getAll({ page: 1, per_page: 5000, hide: true })
      if (result.status === 200) {
        return result.data
      } else {
        throw new Error(result.data)
      }
    }, []),
    useMemo(() => ({ initialData: [] }), []),
  )
}
